const CurrencyModule = {
  carPrice(price){
    return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }
}

export default CurrencyModule
